import saleFullcont from "./sale-fullcont.html";

const dialog = require('../../../../../components/dialog/dialog')
const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const saleDt = require('./sale-dt')
const saleMenu = require('./sale-menu')
const handler = require('./sale-fullcont-handler')
const { formCopy } = require('./sale-fullcont-form')
const { form } = require('./sale-fullcont-form')
const { saleMT } = require('./sale-fullcont-multitable')
const timeDate = require('../../../../../js-handler/time-date')
const settings = require('../../../../../js-handler/settings')
const restriction = require('./sale-fullcont-restriction')
const notification = require('./sale-fullcont-notification')

const customerQuickview = require('../customer/customer-quickview')
const snackS = require('./sale-snack')

/****************ELEMENTS*****************/
var htmlFc = {}
var HTMLwasSelected = false
var input_send_email = false

function HTMLselect(detail) {

      fullcontHandler.HTMLselect(

            'sale', //database table name****
            'sale', //dest entity on js
            'sale-fullcont',
            saleFullcont, form, formCopy, saleMT,
            editDialog, deleteDialog, dtCall, htmlFc)

      HTMLwasSelected = true
      handler.initDataFc(htmlFc)
      // htmlFc.hasFiles = true
      // fullcontHandler.rightsControl(htmlFc) 
}/**/


export function start(detail) {
      //console.log('sale-dt 5>', detail)

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/


const obj = {

      addOne: { start: (detail) => { addOne(detail, htmlFc) } },
      addOnePrint: { start: (detail) => { addOnePrint(detail, htmlFc); } },
      cancelEdit: { start: (detail) => { fullcontEntity.cancelEdit(detail, htmlFc) } },
      deleteEntity: { start: (detail) => { deleteEntity(detail, htmlFc); } },
      deleteFromDialog: { start: (detail) => { deleteFromDialog(detail, htmlFc) } },
      discard: { start: (detail) => { fullcontHandler.discard(detail, htmlFc) } },
      fullcontOptions: { start: (detail) => { saleMenu.start(detail, 'htmlDt', htmlFc) } },
      hide: { start: (detail) => { fullcontEntity.hide(detail, htmlFc) } },
      prepareAdd: { start: (detail) => { fullcontEntity.prepareAdd(detail, htmlFc, process) } },
      prepareEdit: { start: (detail) => { fullcontHandler.prepareEdit(detail, htmlFc) } },
      saveFromDialog: { start: (detail) => { saveFromDialog(detail) } },
      selectOne: { start: (detail) => { fullcontEntity.selectOne(detail, htmlFc, process_required_field_select_one) } },
      selectOneNoCheck: { start: (detail) => { fullcontEntity.selectOneNoCheck(detail, htmlFc, process_required_field_select_one) } },
      update: { start: (detail) => { update(detail); } },
      updatePrint: { start: (detail) => { updatePrint(detail); } },
      otherFieldCustomer: { start: (detail) => { handler.otherFieldCustomer(detail, htmlFc) } },
      otherFieldItem: { start: (detail) => { handler.otherFieldItem(detail, htmlFc) } },
      calculate_values: { start: (detail) => { handler.calculate_values(detail, htmlFc) } },
      calculateGrandTotal: { start: (detail) => { calculateGrandTotal(); } },
      required_field: { start: (detail) => { handler.required_field(htmlFc) } },
      pdfMenuFullcont: { start: (detail) => { handler.pdfMenuFullcont(detail) } },
      pdfFullcontPackSlip: { start: (detail) => { handler.pdfFullcontPackSlip(detail, htmlFc) } },
      addOneFromDialog: { start: (detail) => { fullcontEntity.addOne(detail, htmlFc, process_required_field) } },
      addOnePrintFromDialog: { start: (detail) => { addOnePrintFromDialog(detail) } },
      updateFromDialog: { start: (detail) => { updateFromDialog(detail); } },
      updatePrintFromDialog: { start: (detail) => { updatePrintFromDialog(detail); } },
      shippingnow: { start: (detail) => { handler.shippingnow(htmlFc) } },
      insertshippingdatetime: { start: (detail) => { handler.insertshippingdatetime(htmlFc) } },
      showcost: { start: (detail) => { handler.showcost(htmlFc) } },
      showreturn: { start: (detail) => { handler.showreturn(htmlFc) } },
      verifyQtyItem: { start: (detail) => { handler.verifyQtyItem(htmlFc) } },
      calculatepaymentdue: { start: (detail) => { handler.calculatepaymentdue(htmlFc) } },
      calculate_values_p_vs_lost: { start: (detail) => { handler.calculate_values_p_vs_lost(detail, htmlFc) } },
      beforeAutocomplete: { start: (detail) => { handler.beforeAutocomplete(detail, htmlFc) } },
      otherFieldItemLost: { start: (detail) => { handler.otherFieldItemLost(detail, htmlFc) } },

      obtenerIdCustomer: { start: (detail) => { obtenerIdCustomer(detail, htmlFc) } },

}/**/

function obtenerIdCustomer(detail, htmlFc) {
      let idSale = null;
      const container = htmlFc.fullcontHTML.querySelector('#sale_form_customer_id');

      const chip = container ? container.querySelector('.chip-cont') : null;

      if (chip && chip.childElementCount > 0) {
            const otherFieldElem = container.querySelector(".otherField");
            const rawFields = otherFieldElem ? otherFieldElem.getAttribute('otherField') : null;

            let saleOtherField = null;

            if (rawFields && rawFields !== "undefined" && rawFields !== "null") {
                  try {
                        saleOtherField = JSON.parse(rawFields);
                  } catch (error) {
                        console.error("Error al parsear otherField de customer:", error);
                  }
            }

            if (saleOtherField && saleOtherField.id_customer) {
                  customerQuickview.start({
                        "dest": "customer",
                        "elem": "quickview",
                        "act": "getExtraData",
                        "idCustomer": saleOtherField.id_customer
                  });
                  return;
            }

            idSale = htmlFc.fullcontHTML.getAttribute('data-dbid');
            if (idSale !== null && idSale !== "") {
                  customerQuickview.start({
                        "dest": "customer",
                        "elem": "quickview",
                        "act": "getExtraData",
                        "idSale": idSale
                  });
                  return;
            }
      }

      snackS.start({
            act: 'show',
            id: 'errorCustomer',
            text: 'Select a customer'
      });
}

//function to send
function editDialog() {
      dialog.start({ act: "show", id: "saveChanges", entity: 'sale' })
}

function deleteDialog(detail) {
      dialog.start({ act: "show", dest: 'sale', id: "deleteElem", entity: 'sale', dbid: detail.dbid })
}

function dtCall(act, result) {
      saleDt.start({ act: act, row: result })
}


async function addOne(detail, htmlFc) {
      setInputSendEmail();

      if (!await handler.validated(detail, htmlFc, "add")) {
            if (await handler.checkCreditLimit(detail, htmlFc, "add") != true) {
                  fullcontEntity.addOne(detail, htmlFc, process_required_field)
            }
      }
}

async function addOnePrint(detail, htmlFc) {
      setInputSendEmail();

      if (!await handler.validated(detail, htmlFc, "addPrint")) {
            if (await handler.checkCreditLimit(detail, htmlFc, "addPrint") != true) {
                  fullcontEntity.addOne(detail, htmlFc, process_required_field_print);
            }
      }

}


function deleteFromDialog(detail, htmlFc) {

      fullcontEntity.deleteFromDialog(detail, htmlFc)
      setTimeout(() => {
            saleDt.start({ "dest": "sale", "elem": "dt", "act": "select", "entity": "sale" })
      }, 900)

}

function setInputSendEmail() {
      let input = htmlFc.fullcontHTML.querySelector('#sale_form_send_email input');
      input_send_email = input != undefined ? input.checked : false;
}

function sendSaleInvoiceEmailAfterSave() {
      if (input_send_email) {
            handler.sendSaleInvoiceEmail();
      }
}

function printSaleInvoice() {
      handler.pdfMenuFullcont({ entity: "sale", report: "sale-invoice" });
}

//Function to set default values to fullcont fields when creating a record is pressed
function setDefaultValue(htmlFc) {
      let sale_date = htmlFc.fullcontHTML.querySelector('#sale_form_sale_date input');
      sale_date.value = timeDate.convertDateToInput();

      let sale_statement = htmlFc.fullcontHTML.querySelector('#sale_form_sale_statement textarea');
      sale_statement.value = settings.getData().sale_statement

      let sale_footer = htmlFc.fullcontHTML.querySelector('#sale_form_sale_footer textarea');
      sale_footer.value = settings.getData().sale_footer

      let sale_shipping_status = htmlFc.fullcontHTML.querySelector('#sale_form_shipping_status select');
      sale_shipping_status.value = 'preparing';

      let day_default = '30';
      let sale_form_terms = htmlFc.fullcontHTML.querySelector('#sale_form_terms select');
      sale_form_terms.value = day_default;

      let due_date = htmlFc.fullcontHTML.querySelector('#sale_form_due_date input');
      due_date.value = timeDate.convertDateToInput(new Date().setDate(new Date().getDate() + parseInt(day_default)));

      let sale_showcost = htmlFc.fullcontHTML.querySelector('#showcost');
      sale_showcost.checked = false;

      let sale_showreturn = htmlFc.fullcontHTML.querySelector('#showreturn');
      sale_showreturn.checked = false;

      htmlFc.formCopy.forEach(element => {

            if (element.name == "sale_date") {
                  element.value = sale_date.value;
            }

            if (element.name == "due_date") {
                  element.value = due_date.value;
            }

            if (element.name == "sale_statement") {
                  element.value = sale_statement.value;
            }

            if (element.name == "sale_footer") {
                  element.value = sale_footer.value;
            }

            if (element.name == "shipping_status") {
                  element.value = sale_shipping_status.value;
            }

            if (element.name == "terms") {
                  element.value = sale_form_terms.value;
            }

            if (element.name == "grand_total") {
                  element.value = "0.00";
            }

            if (element.name == "total_profit_pct") {
                  element.value = "0.00 / %0.00";
            }
      });
}

function process_required_field(data, result) {
      handler.required_field(htmlFc)
      restriction.evaluation(htmlFc, result.restriction)
      notification.start(data, result, htmlFc)

      sendSaleInvoiceEmailAfterSave()
      handler.fill_InventoryStock(data)

      let return_mt = htmlFc.fullcontHTML.querySelector('#return');
      return_mt.classList.remove('dn');
      handler.showcost(htmlFc)

}


function process_required_field_saveFromDialog(data = undefined, result) {
      handler.required_field(htmlFc)
      if (data != undefined) {
            restriction.evaluation(htmlFc, result.restriction)
            notification.start(data, result, htmlFc)
            handler.fill_InventoryStock(data);
            sendSaleInvoiceEmailAfterSave()
            let return_mt = htmlFc.fullcontHTML.querySelector('#return');
            return_mt.classList.remove('dn');
            handler.showcost(htmlFc)
      }
}

function process_required_field_update(data = undefined, result) {
      handler.required_field(htmlFc)
      if (data != undefined) {
            restriction.evaluation(htmlFc, result.restriction)
            notification.start(data, result, htmlFc)
            handler.dtgenerator(result, htmlFc);
            sendSaleInvoiceEmailAfterSave()
            handler.fill_InventoryStock(data)
            handler.showcost(htmlFc)
      }
}

function process_required_field_select_one(data, result) {
      // console.log(result)

      handler.required_field(htmlFc)
      handler.fill_InventoryStock(data)
      restriction.evaluation(htmlFc, result.restriction)
      notification.start(data, result, htmlFc)
      handler.dtgenerator(result, htmlFc);
      handler.getemailTraking(result);

      let sale_showcost = htmlFc.fullcontHTML.querySelector('#showcost');
      sale_showcost.checked = false;
      let event = new Event('change');
      sale_showcost.dispatchEvent(event);

      let return_mt = htmlFc.fullcontHTML.querySelector('#return');
      return_mt.classList.remove('dn');

      let sale_showreturn = htmlFc.fullcontHTML.querySelector('#showreturn');
      sale_showreturn.checked = false;

      event = new Event('change');
      sale_showreturn.dispatchEvent(event);

      handler.initChatsFc(result.chats)


}

function process_required_field_print(data, result) {

      handler.required_field(htmlFc)
      restriction.evaluation(htmlFc, result.restriction)
      notification.start(data, result, htmlFc)

      handler.dtgenerator(result, htmlFc);
      printSaleInvoice();
      sendSaleInvoiceEmailAfterSave()

      handler.fill_InventoryStock(data)

      let return_mt = htmlFc.fullcontHTML.querySelector('#return');
      return_mt.classList.remove('dn');

      handler.showcost(htmlFc);
}



function process() {
      setDefaultValue(htmlFc);
      handler.required_field(htmlFc)
      handler.cleandtfullcont(htmlFc);
      handler.calculateGrandTotal(htmlFc);
      handler.calculateGrandTotalReturn(htmlFc);
}




async function saveFromDialog(detail) {
      setInputSendEmail();

      setTimeout(async () => {
            if (!await handler.validated(detail, htmlFc,
                  (htmlFc.fullcontHTML.classList.contains('mode-add') == true ? "add" : "update"))) {
                  let mode = htmlFc.fullcontHTML.classList.contains('mode-add') == true ? "add" : "update";
                  fullcontEntity.saveFromDialog(detail, htmlFc, mode == "add" ? process_required_field_saveFromDialog : process_required_field_update)
            }
      }, 500)

}


async function update(detail) {
      setInputSendEmail();
      if (!await handler.validated(detail, htmlFc, "update")) {
            fullcontEntity.update(detail, htmlFc, process_required_field_update)

      }
}

async function updatePrint(detail) {
      setInputSendEmail();

      if (!await handler.validated(detail, htmlFc, "updatePrint")) {
            fullcontEntity.update(detail, htmlFc, process_required_field_print);
      }
}

function calculateGrandTotal() {
      setTimeout(() => { handler.calculateGrandTotal(htmlFc) }, 900);
}

function updateFromDialog(detail) {
      setInputSendEmail();
      // para que se pase el boton update en vez del boton update del dialogo
      // ya que esto da error al momento de quitar el icono de error de los tab
      detail.ev = { target: htmlFc.fullcontHTML.querySelector('#updateButton') };
      fullcontEntity.update(detail, htmlFc, process_required_field_update)
}

function addOnePrintFromDialog(detail) {
      setInputSendEmail();
      fullcontEntity.addOne(detail, htmlFc, process_required_field_print)
}

function updatePrintFromDialog(detail) {
      setInputSendEmail();
      // para que se pase el boton update en vez del boton update del dialogo
      // ya que esto da error al momento de quitar el icono de error de los tab
      detail.ev = { target: htmlFc.fullcontHTML.querySelector('#updateButton') };
      fullcontEntity.update(detail, htmlFc, process_required_field_print)
}

async function deleteEntity(detail, htmlFc) {
      if (await handler.processpayment(htmlFc, "update", detail.dbid.join(','))) {
            return true;
      } else {
            fullcontEntity.deleteEntity(detail, htmlFc)
      }

}
